var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16229 7.3625L10.5185 1.00625C10.6685 0.85625 10.8435 0.78125 11.0435 0.78125C11.2435 0.78125 11.4185 0.85625 11.5685 1.00625C11.7185 1.15625 11.7935 1.33438 11.7935 1.54063C11.7935 1.74688 11.7185 1.925 11.5685 2.075L4.68729 8.975C4.53729 9.125 4.36229 9.2 4.16229 9.2C3.96229 9.2 3.78729 9.125 3.63729 8.975L0.412289 5.75C0.262289 5.6 0.190414 5.42188 0.196664 5.21563C0.202914 5.00938 0.281039 4.83125 0.431039 4.68125C0.581039 4.53125 0.759164 4.45625 0.965414 4.45625C1.17166 4.45625 1.34979 4.53125 1.49979 4.68125L4.16229 7.3625Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.5046ebd7.svg";
export { ForwardRef as ReactComponent };